(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', 'react-emotion', './Spinners.css'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('react-emotion'), require('./Spinners.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactEmotion, global.Spinners);
    global.Spinners = mod.exports;
  }
})(this, function (exports, _react, _reactEmotion, _Spinners) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Spinner = Spinner;
  exports.SpinnerLarge = SpinnerLarge;

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function Spinner(props) {
    var className = props.className;

    return _react2.default.createElement(
      'svg',
      {
        className: (0, _reactEmotion.cx)(_Spinners.styles.svg, _Spinners.styles.color, className),
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '25 25 50 50'
      },
      _react2.default.createElement('circle', { className: (0, _reactEmotion.cx)(_Spinners.styles.circle, 'path'), cx: '50', cy: '50', r: '20' })
    );
  }

  function SpinnerLarge(props) {
    var className = props.className;

    return _react2.default.createElement(
      'svg',
      {
        className: (0, _reactEmotion.cx)(_Spinners.styles.svg, _Spinners.styles.color, _Spinners.styles.large, className),
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '25 25 50 50'
      },
      _react2.default.createElement('circle', { className: (0, _reactEmotion.cx)(_Spinners.styles.circle, 'path'), cx: '50', cy: '50', r: '20' })
    );
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/LoadingIndicators/Spinners.js
// module id = 1184
// module chunks = 0